import { useLang } from "@/i18n/LangContext";
import { Sparkles, Zap, ChefHat, Check } from "lucide-react";

const icons = [Sparkles, Zap, ChefHat];

export default function Amenities() {
  const { t } = useLang();
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="py-24 sm:py-32 bg-[#FAF9F6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-overline text-[#0097b2] mb-4">
            {t.amenities.overline}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#121C26]">
            {t.amenities.title}
          </h2>
          <p className="mt-5 text-[#4A5D6B] text-base sm:text-lg leading-relaxed">
            {t.amenities.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#E0DACE] border border-[#E0DACE]">
          {t.amenities.groups.map((group, gi) => {
            const Icon = icons[gi] || Sparkles;
            return (
              <div
                key={group.title}
                data-testid={`amenity-group-${gi}`}
                className="bg-[#FAF9F6] p-8 sm:p-10"
              >
                <Icon
                  size={24}
                  strokeWidth={1.25}
                  className="text-[#0097b2] mb-5"
                />
                <h3 className="font-serif text-2xl text-[#121C26] mb-5">
                  {group.title}
                </h3>
                <ul className="space-y-2.5">
                  {group.items.map((item) => (
                    <li
                      key={item}
                      className="flex items-start gap-2.5 text-[#4A5D6B] text-sm sm:text-base"
                    >
                      <Check
                        size={16}
                        strokeWidth={1.75}
                        className="text-[#0097b2] mt-1 shrink-0"
                      />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
